import $ from "jquery";
import * as Common from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";

export default function standart() {}

export const FillTableCallBack = (result, page_number, columnList) => {
  var oTable = $("#example").dataTable();
  window.$nature_protection_Glist = [];
  if (page_number === 1) {
    oTable.fnClearTable();
  }
  if (page_number <= result.meta.total_pages) {
    if (result.data.length > 0) {
      $.each(result.data, function (index, data) {
        var circleType =
          data.content["algemeen-actief"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        var checkbox =
          '<label class="ct-checkbox"><input type="checkbox"><span class="checkmark"></span></label>';
        var wetenschappelijkenaam =
          data.content["algemeen-wetenschappelijkenaam"];
        if (typeof wetenschappelijkenaam === "undefined") {
          wetenschappelijkenaam = "";
        }
        var nederlandsenaam = data.content["algemeen-nederlandsenaam"];
        if (typeof nederlandsenaam === "undefined") {
          nederlandsenaam = "";
        }
        var wet = data.content["algemeen-wet"];
        if (typeof wet === "undefined") {
          wet = "";
        }
        var ovg = data.content["algemeen-ovg"];
        if (typeof ovg === "undefined" || ovg === "null") {
          ovg = "";
        }
        var naamperiode = data.content["algemeen-naamperiode"];
        if (typeof naamperiode === "undefined") {
          naamperiode = "";
        }
        var soort = data.content["algemeen-soort"];
        if (typeof soort === "undefined") {
          soort = "";
        }
        var startperiode = data.content["algemeen-startperiode"];
        if (typeof startperiode === "undefined") {
          startperiode = "";
        }
        var eindeperiode = data.content["algemeen-eindeperiode"];
        if (typeof eindeperiode === "undefined") {
          eindeperiode = "";
        }

        var model = {
          identification: data.identification,
          actief: data.content["algemeen-actief"],
          code: data.content["algemeen-code"],
          omschrijving: data.content["algemeen-omschrijving"],
          nederlandsenaam: nederlandsenaam,
          wetenschappelijkenaam: wetenschappelijkenaam,
          wet: wet,
          ovg: ovg,
          naamperiode: naamperiode,
          soort: soort,
          startperiode: startperiode,
          eindeperiode: eindeperiode,
        };

        var test = {
          checkbox: checkbox,
          active: circleType,
          "Wetenschappelijke naam": wetenschappelijkenaam,
          "Nederlandse naam": nederlandsenaam,
          Wet: wet,
          "Overige statussen": ovg,
          "Naam periode": naamperiode,
          Soort: soort,
          "Begin periode": startperiode,
          "Einde periode": eindeperiode,
        };

        var _columnList = [];
        for (let column in columnList.column_list) {
          for (let key in test) {
            if (
              columnList.column_list[column].toLowerCase() == key.toLowerCase()
            ) {
              _columnList.push(test[key]);
            }
          }
        }

        window.$nature_protection_Glist.push(model);
        var addId = oTable.fnAddData(
          [
            ..._columnList,
            // checkbox,
            // circleType,
            // wetenschappelijkenaam,
            // nederlandsenaam,
            // wet,
            // ovg,
            // naamperiode,
            // soort,
            // startperiode,
            // eindeperiode,
          ],
          false
        );

        var theNode = $("#example").dataTable().fnSettings().aoData[
          addId[0]
        ].nTr;
        theNode.setAttribute("rowId", data["identification"]);
      });
      oTable.fnDraw();
    } else {
      $("tbody").html();
      oTable.fnClearTable();
    }
  }
  $("#total-rows").html(result.meta.total_found);
  window.$nature_protection_table_total_row_count = result.meta.total_found;
  $("#cover-spin").hide(0);
  window.$nature_protection_treeChangeStatus = true;
  window.$nature_protection_scroll_change = true;
};

export const FillFilterColumnsCallBack = (data, result) => {
  if (data.id === "algemeen-code") {
    $.each(result.data.values, function (index, data) {
      window.$nature_protection_algemeenCode.push(data);
    });
  }
};

export const SearchFilterColumnsCallBack = (searchId, result) => {
  if (searchId === "algemeen-wetenschappelijkenaam") {
    window.$nature_protection_search_filter_wetenschappelijkenaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$nature_protection_search_filter_wetenschappelijkenaam.push(data);
    });
  }
  if (searchId === "algemeen-nederlandsenaam") {
    window.$nature_protection_search_filter_nederlandsenaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$nature_protection_search_filter_nederlandsenaam.push(data);
    });
  }
  if (searchId === "algemeen-wet") {
    window.$nature_protection_search_filter_wet.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$nature_protection_search_filter_wet.push(data);
    });
  }
  if (searchId === "algemeen-ovg") {
    window.$nature_protection_search_filter_ovg.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$nature_protection_search_filter_ovg.push(data);
    });
  }
  if (searchId === "algemeen-naamperiode") {
    window.$nature_protection_search_filter_naamperiode.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$nature_protection_search_filter_naamperiode.push(data);
    });
  }
  if (searchId === "algemeen-soort") {
    window.$nature_protection_search_filter_soort.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$nature_protection_search_filter_soort.push(data);
    });
  }
};

export const beheereenheidSavedCallBack = (token) => {
  Common.sleep(2000).then(() => {
    $("#natuurbescherming_toevoegen_modal").modal("hide");
    window.$nature_protection_refresh();
    /*omnimap
      .FillTableAction(window.$nature_protection_lastUsedTableFilter, 1)
      .then((result) => {
        FillTableCallBack(result, 1, window.$nature_protection_columnListPure);
      });*/
  });
};

export const BeheereenheidEditCallBack = () => {
  Common.sleep(1500).then(() => {
    window.$nature_protection_refresh();
    /*omnimap
      .FillTableAction(window.$nature_protection_lastUsedTableFilter, 1)
      .then((result) => {
        FillTableCallBack(result, 1, window.$nature_protection_columnListPure);
      });*/
  });
};

export const RowsDeletedCallBack = (token) => {
  Common.sleep(500).then(() => {
    $("#management-units-mappen_beheren_delete_modal").modal("hide");
    window.$nature_protection_refresh();
    /*omnimap
      .FillTableAction(window.$nature_protection_lastUsedTableFilter, 1, token)
      .then((result) => {
        FillTableCallBack(result, 1, window.$nature_protection_columnListPure);
      });*/
  });
};

export const GetActionsOfRowCallback = async (result) => {
  var actionsOfSelection = [];
  var actionsOfDisabled = [];
  var BreakException = {};

  $.each(result.data.stages, function (index, stage) {
    if (stage.definition.type === "activity" && stage.start_allowed === true) {
      actionsOfSelection.push(stage.definition.identification);
    } else {
      actionsOfDisabled.push(stage.definition);
    }
  });

  $("#myPopup").html("");
  $.each(window.$nature_protection_actions, function (index, action) {
    if ($.inArray(action["id"], actionsOfSelection) !== -1) {
      var anchor = $("<a></a>")
        .attr({ href: "javascript:void(0)", id: action["id"] })
        .addClass(action["class"] + " catalog-action")
        .html(action["text"]);
      $("#myPopup").append(anchor);
    }
  });

  //** aktif olmayan actionlar burada listeleniyor. */
  $.each(actionsOfDisabled, function (index, action) {
    var anchor = $("<a disabled></a>")
      .attr({ href: "javascript:void(0)", id: action["identification"] })
      .addClass("disabled" + " catalog-action")
      .html(action["name"]);
    $("#myPopup").append(anchor);
  });
  var isDelete = true;
  if (result.data.stages.length > 0) {
    let arr = window.$nature_protection_selectedIds;
    for (let i = 0; i < arr.length; i++) {
      let getRowOfDetail = await omnimap.GetRowOfDetailAction(
        arr[i],
        window.$nature_protection_token
      );

      if (
        getRowOfDetail.data.delete_allowed &&
        getRowOfDetail.data.delete_allowed !== undefined
      ) {
        // var verwijderen = $("<a></a>")
        //   .attr({ href: "javascript:void(0)", id: "verwijderen" })
        //   .addClass("trash-bin beheereenheid")
        //   .html("Verwijderen");
        // $("#myPopup").append(verwijderen);
        // break;
        isDelete = true;
      } else {
        // var verwijderen = $('<a style="cursor: no-drop;color: #ccc;"></a>')
        //   .attr({ href: "javascript:void(0)", id: "" })
        //   .addClass("trash-bin beheereenheid")
        //   .html("Verwijderen");
        // verwijderen.append(
        //   `<span class="tooltiptext" style="top: 165px;">kan niet worden verwijderd<br>omdat het in beheerobjects</span>`
        // );
        // $("#myPopup").append(verwijderen);
        // break;

        isDelete = false;
        break;
      }
    }
    if (isDelete) {
      var verwijderen = $("<a></a>")
        .attr({ href: "javascript:void(0)", id: "verwijderen" })
        .addClass("trash-bin beheereenheid")
        .html("Verwijderen");
      $("#myPopup").append(verwijderen);
    } else {
      var verwijderen = $('<a style="cursor: no-drop;color: #ccc;"></a>')
        .attr({ href: "javascript:void(0)", id: "" })
        .addClass("trash-bin beheereenheid")
        .html("Verwijderen");
      verwijderen.append(
        `<span class="tooltiptext" style="top: 165px;">kan niet worden verwijderd<br>omdat het in beheerobjects</span>`
      );
      $("#myPopup").append(verwijderen);
    }
  } else {
    var beheereenheidToevoegen = $("<a></a>")
      .attr({ href: "javascript:void(0)", id: "natuurbescherming_toevoegen" })
      .addClass("maatregelen beheereenheid")
      .html("Natuurbescherming toevoegen");
    $("#myPopup").append(beheereenheidToevoegen);
  }
  let bulkImport = $("<a></a>")
      .attr({ href: "javascript:void(0)", id: "bulk-import" })
      .addClass("maatregelen beheereenheid")
      .html("Bulk import");
  $("#myPopup").append(bulkImport);

  var popup = document.getElementById("myPopup");
  popup.classList.toggle("show");
};

export function TableColumnChangeHandler(
  settings,
  data,
  identification,
  columnOrderReference,
  COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT
) {
  var names = settings.aoColumns;
  if (names[0]) {
  }
  var test_list = [];
  names.forEach((element, index) => {
    test_list.push(element.sTitle);
  });

  var checkIndex = test_list.findIndex((x) => x.includes("checkAll"));
  test_list[checkIndex] = "checkbox";
  var statusIndex = test_list.findIndex((x) => x.includes("snowflake"));
  test_list[statusIndex] = "active";
  var model = {
    identification: identification,
    code: COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT,
    client_identification: COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT,
    reference: columnOrderReference,
    data: {
      table_sorting: [
        {
          name: "catalog>nature-protection",
          column_list: [],
        },
      ],
    },
  };
  var asd = (model.data.table_sorting.find(
    (x) => x.name === "catalog>nature-protection"
  ).column_list = test_list);
  omnimap.GetFreeFormatAction(identification, "PUT", model);

  return model.data.table_sorting[0];
}

export const GetColumnPropertiesCallBack = (data, callType) => {
  var filteredRes = data.data.find((item, i) => {
    if (
      item.identification === process.env.REACT_APP_CATALOG_NATURE_PROTECTION
    ) {
      return i;
    }
  });

  // var result_data =
  //   data.data[process.env.REACT_APP_NODE_ENV == "staging" ? 9 : 2].schema
  //     .properties.algemeen.properties;
  var result_data = filteredRes.schema.properties.algemeen.properties;
  window.$nature_protection_columnList.forEach(function (item) {
    if (item.haveSelect && item.selectProperties != null) {
      if (callType == "create") {
        const selectStatus = document.getElementById(item.createId);
        while (selectStatus.firstChild) {
          selectStatus.removeChild(selectStatus.lastChild);
        }

        if (!item.createRequired) {
          var option = document.createElement("option");
          option.text = "Selecteer";
          option.style = "display:none;";
          selectStatus.add(option);
        }

        result_data[item.selectProperties].enum.forEach((element) => {
          var option = document.createElement("option");
          option.text = element;
          option.value = element;
          selectStatus.add(option);
        });
      } else if (callType == "edit") {
        const editSelectStatus = document.getElementById(item.editId);
        if (editSelectStatus && editSelectStatus.firstChild != null) {
          while (editSelectStatus.firstChild) {
            editSelectStatus.removeChild(editSelectStatus.lastChild);
          }
        }
        result_data[item.selectProperties].enum.forEach((element) => {
          if (item.editId) {
            var option = document.createElement("a");
            option.attributes.href = "javascript:void(0)";
            option.className = "popuptext-dropdown-a";
            option.name = item.editId;
            option.innerText = element;
            editSelectStatus.appendChild(option);
          }
        });
      }
    }
  });
};
